(function($) {
  var header = $('.header');
  var menu = $('.header__menu');
  let offcanvas = false;

  menu.find('a').on('click', function(e) {
    e.preventDefault();
    header.removeClass('header--offcanvas');
    bodyScrollLock.enableBodyScroll(menu[0]);

    var target = $($(this).attr('href').substr(1));

    $('html, body').animate({
        scrollTop: target.offset().top - header.innerHeight() - 20
    }, 500);
  });

  $('.offcanvas-toggle').on('click', function() {
    header.toggleClass('header--offcanvas');
    offcanvas = !offcanvas;

    if (offcanvas) {
      bodyScrollLock.disableBodyScroll(menu[0]);
    } else {
      bodyScrollLock.enableBodyScroll(menu[0]);
    }
  });

  // Wayopints
  menu.find('a').each(function() {
    var link = $(this)
    var section = $(link.attr('href').substr(1));

    // Top Waypoint
    new Waypoint({
      element: section[0],
      handler: function(direction) {
        menu.find('a').removeClass('active');
        link.addClass('active');
      },
      offset: header.innerHeight() + 30
    });

    // Bottom Waypoint
    new Waypoint({
      element: section[0],
      handler: function(direction) {
        menu.find('a').removeClass('active');
        link.addClass('active');
      },
      offset: 'bottom-in-view'
    });
  });

  // Show/hide on scroll
  let cachedScroll = window.pageYOffset;
  var onScroll = function() {
    var scroll = window.pageYOffset;
    var slideUp = scroll > cachedScroll;

    if (cachedScroll >= 0) { // To fix Safari's negative scrolling
      if (slideUp) {
        header.addClass('header--slide-up');
      } else {
        header.removeClass('header--slide-up');
      }
    }

    cachedScroll = scroll
  }

  $(window).on('scroll', $.throttle( 50, onScroll));
})(jQuery);
